import { type Components } from '@mui/material/styles';

import typography from '@/theme/typography';

const MuiListItemButton: Components['MuiListItemButton'] = {
  styleOverrides: {
    root: {
      padding: 0,
      width: '100%',
      '&:hover .MuiTypography-root': {
        fontWeight: typography.fontWeightMedium
      },
      '&:hover svg': {
        color: 'text.primary'
      },
      '& .MuiTypography-root': {
        whiteSpace: 'nowrap'
      },
      '& .MuiListItemText-root': {
        overflow: 'hidden'
      }
    }
  }
} as never;

export default MuiListItemButton;
